// extracted by mini-css-extract-plugin
module.exports = {"body":"style_body__Wmzne","headerless":"style_headerless__y_hck","title":"style_title__Z7i2n"};